import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, lastValueFrom, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})

export class QuestionCategoryService {
    private fetchCategorySource = new BehaviorSubject<boolean | null>(null);
    categoryChanged$ = this.fetchCategorySource.asObservable();
    private GET_ALL_QUESTION_CATEGORY_ENDPOINT = 'question/category/all';
    private GET_ORGANISATION_QUESTION_CATEGORY_ENDPOINT = 'question/category/organisation';

    constructor(
        private http: HttpClient
    ) { }

    public getAllQuestionCategories(resolver = false): Observable<any> | any | Promise<any> {
        const response = this.http.get(environment.apiBase + this.GET_ALL_QUESTION_CATEGORY_ENDPOINT);
        return resolver ? response : lastValueFrom(response);
    }

    public getOrganisationQuestionCategories(resolver = false): Observable<any> | any | Promise<any> {
        const response = this.http.get(environment.apiBase + this.GET_ORGANISATION_QUESTION_CATEGORY_ENDPOINT);
        return resolver ? response : lastValueFrom(response);
    }

    setCategory(data: boolean | null) {
        this.fetchCategorySource.next(data);
    }

}

export interface StoreOrganisationQuestionCategoryBody {
    organisationId: number;
    questionCategories: {id: number, name: string, slug: string, enabled: boolean}[];
    assetCategories: {id: number, name: string, slug: string, enabled: boolean}[];
}